import {
  Component,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { ApAlertService } from 'webcommon/core-ui';
import { FcListValidationService, FormGroupArray } from '../../generic/fc-list-validation/fc-list-validation.service';
import { FormGroup, FormControl } from '@angular/forms';
import {
  FcPatientProgramListItemDto,
  FormGroupValidationRules,
  FcModifyPatientProgramListItemDto,
  PatientProgramFormGroupDTO,
  PatientProgramGeneralTabFormGroupDTO,
  FacilityPortalPersonFormArrayDTO
} from 'webcommon/shared';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'ap-fc-patient-program-list-modal',
  templateUrl: './fc-patient-program-list-modal.component.html',
  styleUrls: ['./fc-patient-program-list-modal.component.less']
})
export class FcPatientProgramListModalComponent extends FcGenericItemModalBaseComponent implements OnInit, AfterViewInit {
  public override baseId = 'fc-patient-program-item';
  public isTabDisabled = true;

  public listItem: FcPatientProgramListItemDto = {
    Id: '',
    ExternalID: '',
    Name: '',
    Color: '',
    ToolbarText: '',
    Notes: '',
    Inactive: false,
    UserDefined: true,
    PatientProgramUid: this.systemGuid.GuidEmpty,
    RelPatientProgramPersonWeb: [],
  };

  public generalGroup = new FormGroup<PatientProgramGeneralTabFormGroupDTO>({});
  public facilityPortalAccessGroup = new FormGroup<FacilityPortalPersonFormArrayDTO>({});

  public listItemDefaultValidation: FormGroupValidationRules = {};

  public form: FormGroup = new FormGroup<PatientProgramFormGroupDTO>({
    general: this.generalGroup,
    facilityPortalAccess: this.facilityPortalAccessGroup,
  });

  public override ngOnInit(): void {
    super.ngOnInit();
    this.loadListItem(this.listItemDefaultValidation);
  }

  public ngAfterViewInit(): void {
    this.disabledFacilityPortalAccessTab();
  }

  public setForm(): void {
    this.validateForm();
  }

  public disabledFacilityPortalAccessTab(): boolean {
    const generalFormGroup = this.form.get('general') as FormGroup;
    const nameControl = generalFormGroup.get('name') as FormControl;
    nameControl.valueChanges.pipe(this.takeUntilDestroy())
      .subscribe((value) => {
        if (value) {
          this.isTabDisabled = false;
        } else this.isTabDisabled = true;
      });
    return this.isTabDisabled;
  }

  public getFormValidationErrors(formGroup: FormGroupArray): number {
    return FcListValidationService.getFormValidationErrors(formGroup, this.isSubmitted);
  }

  public override save(): void {
    const values = this.form.getRawValue();
    const general = values.general;
    const facilityPortalAccess = values.facilityPortalAccess.facilityPortalPersonFormArray;
    const newFacilityPortalAccess = facilityPortalAccess.map((obj: Record<string, string>) => {
      const { Pk, ...rest } = obj;
      return rest;
    });
    this.isSubmitted = true;
    const modifyItemDto: FcModifyPatientProgramListItemDto = {
      Id: general.id,
      ExternalID: general.externalId,
      PatientProgramUid: general.patientProgramUid,
      Name: general.name,
      Color: general.color,
      ToolbarText: general.toolbarText,
      Notes: general.notes,
      Inactive: general.inactive,
      UserDefined: general.userDefined,
      RelPatientProgramPersonWeb: newFacilityPortalAccess,
    };
    super.save<FcModifyPatientProgramListItemDto>(modifyItemDto);
  }
}
